export const branch_list = [
    {name: '中興', value: 'G'}, {name: '仁愛', value: 'F'},
    {name: '和平', value: 'H'}, {name: '婦幼', value: 'J'},
    {name: '陽明', value: 'M'}, {name: '忠孝', value: 'Q'},
    {name: '林森', value: 'X'}, {name: '昆明', value: 'W'},
    {name: '松德', value: 'K'}, {name: '中醫', value: 'S'}];

export function formatBranchNameToBranchCode(branch_name) {
    let branch = branch_list.find(el=>{
        return el.name === branch_name;
    });
    return branch.value;
}

export function formatBranchCodeToBranchName(branch_code) {
    let branch = branch_list.find(el=>{
        return el.value === branch_code;
    });
    return branch.name;
}
